import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LABEL } from '@veriables';
import { voidItm } from '@reducers/orders';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { setErrorPopUp } from '@reducers/notification';
import { openManagerCheck } from '@reducers/oauth';

export const useVoidFlow = (seat) => {
  const dispatch = useDispatch();
  const deviceInfo = useSelector(s => s.oauth.deviceInformation);
  const userInfo = useSelector(s => s.oauth.loggedInUserData);
  const auth = useSelector(s => s.oauth.authInfo);
  const isManagerCheck = useSelector(s => s.oauth.isManagerCheck);

  const [isVoidOpen, setIsVoidOpen] = useState(false);
  const [voidItemData, setVoidItemData] = useState(null);

  const handleManagerAuthentication = useCallback(
    (data, titleHead) => {
      setVoidItemData(data);
      if (userInfo && userInfo.jobTypeId !== 1) {
        if (auth?.nonIntegratedPos === true) {
          dispatch(openManagerCheck(titleHead));
        } else {
          setIsVoidOpen(true);
        }
      } else {
        setIsVoidOpen(true);
      }
    },
    [userInfo, auth?.nonIntegratedPos, dispatch]
  );

  const handleVoidItems = useCallback(() => {
    if (!voidItemData?.selectedItem?.length || !voidItemData?.id) return;
    const payload = {
      employeeId: Number(userInfo?.id),
      storeId: deviceInfo?.storeId,
      checkHeaderId: voidItemData.id,
      items: voidItemData.selectedItem.map(i => ({ checkItemId: i.id })),
    };
    dispatch(voidItm(payload))
      .then(res => dispatch(updateChecksAfterResponse(res)))
      .catch(err => dispatch(setErrorPopUp({ res: err.message })));
  }, [dispatch, deviceInfo, userInfo, voidItemData]);

  return {
    isVoidOpen,
    setIsVoidOpen,
    isManagerCheck,
    handleManagerAuthentication,
    handleVoidItems,
  };
};
